<template lang="pug">
  .checkbox-facet
    .name {{ name }}
    label.checkbox-wrapper.option(v-for="option in shownOptions" :key="option.epci")
      input(
        type="checkbox"
        :checked="values.includes(option[itemValue])"
        :value="option[itemValue]"
        @input="cbInputHandler"
      )
      .checkbox-indicator
      .text {{ option[itemText] }}
      .count ({{ option[itemCount] }})
    button.show-more-btn(
      v-if="options.length > 4"
      @click="showMore = !showMore"
    ) {{ showMore ? 'Montrer moins' : 'Montrer plus' }}
</template>

<script>
import facetMixin from '@/components/facets/facetDisplayMixin.js';

export default {
  mixins: [facetMixin],
  data() {
    return {
      showMore: false,
    }
  },
  methods: {
    cbInputHandler(e) {
      const { checked, value } = e.target;
      const newValues = this.toggleInArray(this.values, value, checked);
      this.$emit('change', newValues);
    },
  },
  computed: {
    shownOptions() {
      return this.showMore ? this.options : this.options.slice(0, 4);
    },
  },
}
</script>

<style lang="scss" scoped>
  .checkbox-facet {
    .option {
      display: flex;
      align-items: center;
      margin: 1em 0;
      .count {
        margin-left: .2em;
      }
      .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .checkbox-indicator {
        top: 0;
      }
    }
    .show-more-btn {
      background: none;
      border: none;
      outline: none;
      padding: 0;
      color: #7A7A7A;
      text-decoration: underline;
    }
  }
</style>